module.exports = __webpack_public_path__ + "img/sun.be5030ca.webp";